import React from 'react';

import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import { venueListNotificationsApi } from '../../../api/notifications/venueListNotificationsApi';
import {
  NotificationType,
  SortDirection,
  UserNotificationStatus,
  VenueNotification,
} from '../../../graphql/API';

export const NOTIFICATIONS_PAGE_LIMIT = 20;

const DEFAULT_STATUS: UserNotificationStatus[] = [
  UserNotificationStatus.sent,
  UserNotificationStatus.read,
];

export const useVenueListNotificationsQuery = (venueID: string | undefined, pageLimit = NOTIFICATIONS_PAGE_LIMIT) => {
  const { data, isFetching, isLoading, fetchNextPage, hasNextPage, refetch } = useInfiniteQuery({
    initialPageParam: 0,
    queryKey: ['venueListNotifications', venueID],
    queryFn: async ({ pageParam }) => {
      const offset = <number>pageParam * pageLimit;

      return venueListNotificationsApi({
        venueID: venueID!,
        type: NotificationType.push,
        status: DEFAULT_STATUS,
        sortDirection: SortDirection.desc,
        offset,
        limit: pageLimit,
      });
    },
    getNextPageParam: (lastGroup, groups) =>
      lastGroup.length === pageLimit ? groups.length : undefined,
    placeholderData: keepPreviousData,
    enabled: !!venueID,
    refetchOnWindowFocus: false,
  });

  const flatData = React.useMemo<VenueNotification[]>(
    () => data?.pages.flatMap((x) => x) ?? [],
    [data],
  );

  return { data: flatData, isFetching, isLoading, fetchNextPage, hasNextPage, refetch };
};
